var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16887 12.6769L7.5902 12.4522L8.46106 14.1939L9.95003 12.0026L7.02837 7.59176L2.56149 0.764943C2.36474 0.4559 1.91538 0.343615 1.60635 0.540167C0.651208 1.10199 0.257894 2.25389 0.651208 3.26527L3.88191 11.5249C4.35948 12.8453 5.93271 13.3791 7.16889 12.6768L7.16887 12.6769Z",
    fill: "#040707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.619 16.0483L11.0176 19.3353L14.3326 26.0217C14.8381 27.0331 16.0743 27.4264 17.0577 26.8645L17.2262 26.7522C18.2096 26.1904 18.5186 24.898 17.8723 23.9709L12.619 16.0483Z",
    fill: "#040707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3168 2.84372C20.0358 2.59092 19.6145 2.67518 19.4177 2.98423C19.4177 2.98423 16.8894 7.17027 16.1588 8.35016C16.0465 8.51869 15.8217 8.57493 15.6532 8.49067C15.4847 8.37838 15.4004 8.1536 15.5127 7.98508C16.187 6.7489 18.5188 2.47868 18.5188 2.47868C18.6874 2.16963 18.5469 1.77633 18.1818 1.63581C17.929 1.55154 17.6479 1.66383 17.5075 1.88861L14.2485 7.25454C14.1362 7.42307 13.9115 7.47932 13.7429 7.39505C13.5744 7.28276 13.4901 7.05798 13.6024 6.88946C14.2767 5.65328 16.6086 1.38306 16.6086 1.38306C16.7771 1.07402 16.6366 0.680712 16.2715 0.540193C16.0187 0.455926 15.7377 0.568216 15.5972 0.792993L12.1417 6.46796L11.7204 7.22654C11.2708 7.98513 11.1303 8.88403 11.3271 9.58638L11.7484 11.1033L3.06739 23.9423C2.44932 24.8974 2.73032 26.1616 3.7135 26.7236L3.88203 26.8359C4.86542 27.3977 6.12959 27.0326 6.60714 25.993L13.3778 12.0585L14.8947 11.6652C15.6251 11.4684 16.2994 10.9066 16.749 10.1482L17.1703 9.3896L20.345 3.57416C20.5695 3.32136 20.5415 3.01233 20.3167 2.84377L20.3168 2.84372Z",
    fill: "#040707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/F&BIcon.5f37a474b7a6d00d95182a07e70b2e94.svg";
export { ForwardRef as ReactComponent };